import Component from './TikTokPostFilter.vue'
export default Component
